import React from 'react';
import { Link } from 'react-router-dom';
import StaticPageLayout from './StaticPageLayout';

const NotFoundPage = () => {
  return (
    <StaticPageLayout title="Page Not Found">
      <p>
        The page you are looking for does not exist or may have moved.
      </p>
      <p>
        You can go back to the <Link to="/">home page</Link> and continue from there.
      </p>
      <p className="static-page__muted">
        If you reached this page from a broken link, please contact support so
        we can fix it.
      </p>
    </StaticPageLayout>
  );
};

export default NotFoundPage;
